export default __webpack_public_path__ + "35e4ebf2a0484926f900d8e975ca7525.webp";